import { Button } from "@components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@components/ui/dialog";
import { Label } from "@components/ui/label";
import { RadioGroup, RadioGroupItem } from "@components/ui/radio-group";
import React, { SetStateAction, useState } from "react";

type InviteTypeDialogProps = {
  openDialog: boolean;
  setOpenDialog: React.Dispatch<SetStateAction<boolean>>;
  onChange: (value: string) => void;
};

const InviteTypeDialog = (props: InviteTypeDialogProps) => {
  const { openDialog, setOpenDialog, onChange } = props;
  const [selectedOption, setSelectedOption] = useState("meetingPoll");

  return (
    <Dialog open={openDialog} onOpenChange={setOpenDialog}>
      <DialogContent className="bg-white w-[340px] max-w-[340px]">
        <DialogHeader>
          <DialogTitle className="text-sm leading-[1.2rem]">
            Would you like to send the candidate multiple time slots to choose
            from, or schedule a specific time slot?
          </DialogTitle>
        </DialogHeader>
        <div className="flex gap-4 my-2">
          <RadioGroup
            defaultValue="meetingPoll"
            onValueChange={(value) => setSelectedOption(value)}
          >
            <div className="flex items-center gap-3">
              <RadioGroupItem value="meetingPoll" id="r1" />
              <Label htmlFor="r1">Multiple time-slots</Label>
            </div>
            <div className="flex items-center gap-3">
              <RadioGroupItem value="invite" id="r2" />
              <Label htmlFor="r2">Specific time-slot</Label>
            </div>
          </RadioGroup>
        </div>
        <DialogFooter>
          {/* <DialogClose asChild>
            <Button variant="outline">Cancel</Button>
          </DialogClose> */}
          <Button
            onClick={() => {
                onChange && onChange(selectedOption)
                setOpenDialog(false)
            }}
            type="submit"
            className="text-white"
          >
            Continue
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default InviteTypeDialog;
